'use client';

import { useEffect, useRef, useState } from 'react';

export function useGridFullRows<TItem>(
  items: TItem[],
  hasMore = true, // Does the full list have more items beyond what is provided?
) {
  const gridRef = useRef<HTMLDivElement | null>(null);
  const [itemsPerRow, setItemsPerRow] = useState<number | null>(null);

  useEffect(() => {
    const currentGrid = gridRef.current;
    if (!currentGrid || !items?.length) return;

    const observer = new ResizeObserver((entries) => {
      const grid = entries[0].target;
      const children = Array.from(grid.children);

      if (children.length < 2) {
        setItemsPerRow(null);
        return;
      }

      const firstTop = (children[0] as HTMLElement).offsetTop;
      let count = 1;

      for (let i = 1; i < children.length; i++) {
        if ((children[i] as HTMLElement).offsetTop !== firstTop) {
          break;
        }
        count++;
      }

      setItemsPerRow(count);
    });

    observer.observe(currentGrid);
    return () => observer.disconnect();
  }, [items]);

  const visibleItems = !hasMore
    ? items // If the list has no more, then we skip the hiding imcomplete rows behavior and show all
    : itemsPerRow && items
      ? items.slice(0, Math.floor(items.length / itemsPerRow) * itemsPerRow)
      : items || [];

  return {
    gridRef,
    visibleItems,
  };
}
